import React from 'react';

import Banner from './banner';
import withPageComponents from '../../page/components/with-page-components';

import './results-footer-banner.less';

const InlineBanner = ({ vwaResultsInlineBanner }) => {
    if (!vwaResultsInlineBanner) return null;
    return <Banner className="inlineBanner" banner={vwaResultsInlineBanner} />;
};

export default withPageComponents(InlineBanner, { components: ['vwaResultsInlineBanner'] });
